var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bly-tooltip",class:_vm.classes},[_vm._t("default"),_c('span',{staticClass:"invisible bly-tooltip-text bly-tooltip-top text-xs"},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }